<template>
  <div v-if="tapStore?.currentTapLang?.blocks?.length">
    <draggable v-model="tapStore.currentTapLang.blocks" item-key="id" handle=".drag-block" ghost-class="ghost" chosen-class="chosen"
               :force-fallback="true" group="blocks"
               class="blocks d-flex flex-column" @start="onStart" @end="onEnd">
      <transition-group type="transition" :name="!dnd.dragBlock.value ? 'fade1' : null" @before-leave="dnd.beforeLeave">
        <TapBlock v-for="block in tapStore.currentTapLang.blocks" :key="block.id" :block="block"/>
      </transition-group>
    </draggable>
  </div>
</template>


<script setup lang="ts">
import { VueDraggableNext as draggable } from 'vue-draggable-next'
import TapBlock from './TapBlock.vue'
import { useDnd } from '@/composables/useDnd'
import { useBlocks } from '@/composables/useBlocks'
import {useTapStore} from '@/stores/tapStore';

const { normalizeBlocksOrder, saveMoveBlock } = useBlocks()
const dnd = useDnd()

const tapStore = useTapStore();
const onStart = () => {
  dnd.dragBlock.value = true;
  dnd.dragInProgress.value = true
}
const onEnd = (event) => {
  saveMoveBlock(event.item._underlying_vm_.uniqueId, event.newIndex)
  normalizeBlocksOrder()
  setTimeout(() => {
    dnd.dragBlock.value = false
    dnd.dragInProgress.value = false
  }, 1)
}
</script>

<style scoped lang="sass">
.chosen
  opacity: 1 !important

.ghost
  opacity: 0 !important

.fade1-move
  transition: transform 0.5s ease

.fade1-leave-active
  transition: opacity 0.2s ease, height 0.25s ease, padding 0.25s ease, margin 0.25s ease

.fade1-leave-from
  opacity: 1
  height: var(--real-height)
  margin-bottom: 8px
  padding: 16px 8px!important
  margin-top: 0
  &:last-child
    margin-bottom: 0

.fade1-leave-to
  opacity: 0
  height: 0
  margin-bottom: 0
  padding: 0!important
  &:last-child
    &:not(:first-child)
      margin-top: -8px

.fade1-enter-active
  transition: opacity 0.2s ease, height 0.25s ease, padding 0.25s ease, margin 0.25s ease

.fade1-enter-from
  opacity: 0
  height: 0
  margin-bottom: 0
  padding: 0!important
  margin-top: 0


.fade1-enter-to
  opacity: 1
  height: var(--real-height)
  margin-bottom: 8px
  padding: 16px 8px!important
  &:last-child
    margin-bottom: 0
    &:not(:first-child)
      margin-top: -8px
</style>
